import { render } from "./EmoticonFace1.vue?vue&type=template&id=ed8d21ea&ts=true"
import script from "./EmoticonFace1.vue?vue&type=script&lang=ts"
export * from "./EmoticonFace1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__